import { Record } from 'immutable';

export default class CustomerAttestRecord extends Record({
  id: undefined,
  createdAt: undefined,
  customerAttestResources: undefined,
  person: undefined,
}) {
}
